var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSessionTimeout = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 27,
  viewBox: "0 0 27 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.941406,
  width: 26,
  height: 26,
  rx: 13,
  fill: "url(#paint0_linear_42121_64904)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.0212 7.98384C12.0212 7.4105 12.4903 6.94141 13.0636 6.94141C13.637 6.94141 14.1061 7.4105 14.1061 7.98384V14.2384C14.1061 14.8118 13.637 15.2809 13.0636 15.2809C12.4903 15.2809 12.0212 14.8118 12.0212 14.2384V7.98384ZM13.0636 20.493C12.1984 20.493 11.5 19.7946 11.5 18.9294C11.5 18.0641 12.1984 17.3657 13.0636 17.3657C13.9289 17.3657 14.6273 18.0641 14.6273 18.9294C14.6273 19.7946 13.9289 20.493 13.0636 20.493Z",
  fill: "url(#paint1_linear_42121_64904)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0212 7.98384C12.0212 7.4105 12.4903 6.94141 13.0636 6.94141C13.637 6.94141 14.1061 7.4105 14.1061 7.98384V14.2384C14.1061 14.8118 13.637 15.2809 13.0636 15.2809C12.4903 15.2809 12.0212 14.8118 12.0212 14.2384V7.98384Z",
  fill: "#FF5C00"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0636 20.493C12.1984 20.493 11.5 19.7946 11.5 18.9294C11.5 18.0641 12.1984 17.3657 13.0636 17.3657C13.9289 17.3657 14.6273 18.0641 14.6273 18.9294C14.6273 19.7946 13.9289 20.493 13.0636 20.493Z",
  fill: "#FF5C00"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_42121_64904",
  x1: 13.5,
  y1: 0.941406,
  x2: 13.5,
  y2: 26.9414,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBE261"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1A738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_42121_64904",
  x1: 13.0625,
  y1: 1.73047,
  x2: 13.0625,
  y2: 23.6111,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#FBE261"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1A738"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSessionTimeout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/session_timeout.ae69cafc02dcdd5f5a5746320bed02d7.svg";